import React, { useEffect } from "react";
import Navbar from "../components/Navbar.js";
import NavbarFixed from "../components/Navbar-Fixed.js";

// components
import RegisterForm from "../components/Register";
import NavbarNew from "../components/Navbar-New.js";
import FooterNew from "../components/Footer-New.js";



export default function Register() {
  return (
    <div>
     
      {/* <NavbarNew /> */}
      <div className="auth_wrapper">
        <RegisterForm />
      </div>
      {/* <FooterNew /> */}
      {/* <NavbarFixed /> */}
    </div>
  );
}
